export default __webpack_public_path__ + "static/media/expertise.18e70b47.svg";